// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2xdPc","header":"styles_header__qDfqx","grid":"styles_grid__mSC0i","destination":"styles_destination__a-Dm6"};